module.exports = __webpack_public_path__ + "img/alterapayBlack.bb63e597.gif";